import * as Yup from 'yup';
import {
  LoginFormTypes,
  ForgotPasswordFormTypes,
  EmailVerificationFormTypes,
  ResetPasswordFormTypes
} from './auth';

export const loginInitialValues: LoginFormTypes = {
  email: '',
  password: '',
  rememberMe: false
}

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email('Please enter a valid email address.')
    .required('Please enter your email address.'),
  password: Yup.string()
    .required('Please enter your password.')
});

export const forgotPasswordInitialValues: ForgotPasswordFormTypes = {
  email: '',
}

export const forgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address.')
    .required('Email ID is required.'),
});

export const resetPasswordInitialValues: ResetPasswordFormTypes = {
  newPassword: '',
  confirmPassword: '',
}

export const resetPasswordValidationSchema = Yup.object({
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters long.')
    .required('Password is required.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match.')
    .required('Confirm Password is required.'),
});

export const emailVerificationInitialValues: EmailVerificationFormTypes = {
  otp: null,
}

export const emailVerificationValidationSchema = Yup.object({
  otp: Yup.string()
    .matches(/^\d{6}$/, 'OTP must be exactly 6 digits.')
    .required('OTP is required.')
})
